import * as React from 'react';
import { useContext } from 'react';
import { getEcsConfig } from './ecsClient';
import { EcsConfig } from './EcsConfig';
import {
  IEcsConfigProps,
  IEcsConfigProviderProps,
  IEcsConfigProviderState
} from './EcsConfigProvider.types';

export const EcsConfigContext = React.createContext<IEcsConfigProps>({
  ecsConfig: EcsConfig.getDefault()
});

export class EcsConfigProvider extends React.Component<
  IEcsConfigProviderProps,
  IEcsConfigProviderState
> {
  constructor(props: IEcsConfigProviderProps) {
    super(props);
    this.state = {
      ecsConfig: EcsConfig.getDefault()
    };
  }

  public render(): JSX.Element {
    return (
      <EcsConfigContext.Provider value={this.state}>
        {this.props.children}
      </EcsConfigContext.Provider>
    );
  }

  public async componentDidMount(): Promise<void> {
    try {
      let ecsConfig = await getEcsConfig();
      this.setState({
        ecsConfig: ecsConfig
      });
    } catch (error) {
      console.error(`EcsConfig: failed to get ECS config because of ${error}`);
    }
  }
}

export const useEcsConfig = () => useContext<IEcsConfigProps>(EcsConfigContext);
